module.exports = __webpack_public_path__ + "img/hr-V-L-1-unload-connect-shadow.2bd94e28.png";